module.exports = __webpack_public_path__ + "img/20190718162843568.bd84a6c7.png";